import { ShieldCheck } from 'lucide-react'
import { de } from '../i18n'
import { SidebarNav } from './SidebarNav'

/**
 * Unlike apps/web's Sidebar, this one does not collapse — three
 * destinations never crowd a fixed-width rail the way a growing nav would,
 * so the toggle would be a control with nothing to earn its keep.
 */
export function Sidebar() {
  return (
    <nav
      aria-label={de.app.name}
      className="hidden w-(--sidebar-width) shrink-0 flex-col border-r border-rule bg-surface lg:flex"
    >
      <div className="flex h-(--topbar-height) items-center gap-2 border-b border-rule px-4">
        <span aria-hidden className="flex size-6 shrink-0 items-center justify-center rounded-[var(--radius-control)] bg-accent-solid text-accent-solid-ink">
          <ShieldCheck className="size-3.5" />
        </span>
        <span className="truncate text-base font-semibold tracking-tight text-ink">
          {de.app.name} <span className="font-normal text-ink-muted">{de.app.suiteName}</span>
        </span>
      </div>

      <SidebarNav />
    </nav>
  )
}
